<template>
  <div class="popup-wrapper ion-margin">
    <h2 class="ion-margin">{{ $t('payment') }}</h2>

    <form
      ref="form"
      class="paymentWidgets"
      :data-brands="brands"
      :action="action"
    ></form>
  </div>
</template>

<script setup>
import { onMounted, ref, nextTick, computed, watch } from "vue";
import { useRoute } from "vue-router";
import store from '../main'
import { isPlatform } from '@ionic/vue';
import { getClubInfo } from '@/composition'

const httpLink = store.getters.httpLink
const clubInfo = ref(getClubInfo())


const brands = computed(() =>
  clubInfo.value?.clubInfo?.MeteorPaymentTypes || ""
)

const srcLink = computed(() =>
  clubInfo.value?.clubInfo?.MeteorScriptLink || ""
)

const route = useRoute();
const form = ref(null);
const action = isPlatform('capacitor') ? ref(`${httpLink.replace('backend-', '')}/hyperpay-result`) : ref(`${window.location.origin}/hyperpay-result`);

watch(srcLink, async (val) => {
  if (!val) return

  const checkoutId = route.query.checkoutId
  if (!checkoutId) return

  await nextTick()

  window.wpwlOptions = {
    locale: "de"
  }

  const script = document.createElement("script")
  script.src = `${val}${checkoutId}`
  script.async = true

  document.body.appendChild(script)
})

onMounted(() => {

});
</script>

<style>
.popup-wrapper {
  max-width: 480px;
  width: 90%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
